import React, { useContext, useEffect, useState } from 'react'
import { AnimatePresence, motion } from "framer-motion";
import starter from '../../Assets/Images/starter.png'
import flow from '../../Assets/Images/flow.png'
import leadership from '../../Assets/Images/leadership.png'
import mindset from '../../Assets/Images/mindset.png'
import Conditional from "../../Assets/Images/conditional_2.png"
import { Button } from '@mui/material'
import leftArrowIcon from '../../Assets/Images/leftArrowIcone.svg'
import emptyImage from "../../Assets/Images/explainer-page.png";
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import { useNavigate, useParams, useSearchParams, useLocation, json } from 'react-router-dom'
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import useEnsureAssessmentDetails from '../../Hooks/useEnsureAssessmentDetails';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext';

const Explainer = () => {

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [hasLeader, setHasLeader] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const [clientId, setClientId] = useState(null)
  const [leader, setLeader] = useState(null);
  const [member, setMember] = useState(null);
  const [respondentName, setRespondentName] = useState(null);
  const [selfUserName, setSelfUserName] = useState(null)
  const [direction, setDirection] = useState(1);
  const [transitionDirection, setTransitionDirection] = useState("right");
  const { windowWidth } = useWindowDimensions();
  const { id } = useParams();
  const assessCtx = useContext(AssessmentQuestionContext)
  useEnsureAssessmentDetails(id, searchParams);

  const categories = [
    {
      title: "1. Starter Quadrant",
      description: hasLeader ?
        // "Identifies a person's unique starting point to understand which quadrant primarily powers them."
        ["Discover your unique", "starting point— the", "quadrant that drives you."]
        : ["Discover your unique", "starting point— the", "quadrant that drives you."],
      image: starter,
    },
    {
      title: "2. Flow",
      description: hasLeader ?
        // "Explores how a person navigates these quadrants to identify where they thrive and where they survive."
        ["Follow your flow", "to uncover how", "you're wired."]
        : ["Follow your flow", "to uncover how", "you're wired."],
      image: flow,
    },
    {
      title: "3. Leadership Style",
      description: hasLeader ?
        // "Assesses a person's leadership style to uncover how they lead, drive growth, and inspire their team."
        ["Identify your leadership", "style—how you lead, grow,", "and inspire."]
        : ["Identify your leadership", "style—how you lead, grow,", "and inspire."],
      image: leadership,
    },
    {
      title: "4. Mindset",
      description: hasLeader ?
        // "Evaluates whether a person's mindset is flexible or focused so that they can unleash their true potential."
        ["Explore the primary", "mindset that shapes your", "life and leadership."]
        : ["Explore the primary", "mindset that shapes your", "life and leadership."],
      image: Conditional,
    }
  ];

  // Initialize currentIndex based on the location state
  const [currentIndex, setCurrentIndex] = useState(
    location.state?.showAllCards ? categories.length - 1 : 0
  );

  useEffect(() => {
    const localStorageKey = `searchParams-${id}`;
    const storedData = JSON.parse(localStorage.getItem(localStorageKey)) || {};

    if (!storedData.leader || !storedData.member) {
      const newStoredData = {
        ...storedData,
        leader: searchParams.get("leader") || null,
        member: searchParams.get("member") || null,
        respondentName: searchParams.get("respondentName") || null,
        userName: storedData.userName || storedData.selfUserName || null,
        clientId: storedData.clientId || null,
        orgId: storedData.orgId || null,
        isLastAsmt: storedData?.isLastAsmt
      };
      localStorage.setItem(localStorageKey, JSON.stringify(newStoredData));
      setLeader(newStoredData.leader);
      setMember(newStoredData.member);
      setRespondentName(newStoredData.respondentName);
      setSelfUserName(newStoredData.userName);
      setClientId(newStoredData.clientId)
      setHasLeader(!!newStoredData.leader);
    } else {
      setLeader(storedData.leader || null);
      setMember(storedData.member || null);
      setRespondentName(storedData.respondentName || null);
      setSelfUserName(storedData.userName || null);
      setHasLeader(!!storedData.leader);
      setClientId(storedData.clientId || null)
    }

    if (location.state?.showAllCards) {
      setCurrentIndex(categories.length - 1);
      setDirection(-1);
      setTransitionDirection("left");
    } else {
      setCurrentIndex(0);
      setDirection(1);
      setTransitionDirection("right");
    }
  }, [location, categories.length, windowWidth]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    assessCtx?.setLeaderName(storedData.leader)
  }, [])

  console.log("respondentName", leader)
  console.log("respondentMember", member)
  console.log("searchParams", searchParams)

  const continueToAssessment = () => {
    const navigationParams = new URLSearchParams(searchParams);
    ["userName", "orgId", "clientId", "leader", "member", "client"].forEach((key) => navigationParams.delete(key));

    // if (window.innerWidth < 650) {
    //   navigate(`/assessment/${params.id}/866/?${newSearchParams.toString()}`, { 
    //     replace: true 
    //   });
    // } else {
    //   navigate(`/before-you-begin/${params.id}/?${searchParams}`, { 
    //     replace: true, 
    //     state: { leader, member, respondentName, selfUserName }
    //   });
    // }
    navigate(`/before-you-begin/${params.id}/?${navigationParams.toString()}`, {
      replace: true,
      state: { leader, member, respondentName, selfUserName, clientId, fromExplainer: true }
    });
  }

  useEffect(() => {
    if (searchParams.get("leader")) {
      setHasLeader(true);
    }

  }, [searchParams])

  const handleNext = () => {
    if (currentIndex < categories.length - 1) {
      setTransitionDirection('right')
      setDirection(1);
      setCurrentIndex(currentIndex + 1);
    }
    else {
      continueToAssessment();
    }
  };

  const handleContinue = () => {
    continueToAssessment()
  }

  const handleBack = () => {
    const localStorageKey = `searchParams-${id}`;
    const searchParamsLocal = JSON.parse(localStorage.getItem(localStorageKey)) || {};
    const existingSearchParams = new URLSearchParams(location.search);

    if (currentIndex === 0) {
      const queryParams = new URLSearchParams();

      if (id) {
        queryParams.append("assessmentId", id);
      }

      existingSearchParams.forEach((value, key) => {
        if (!["userName", "orgId", "clientId", "leader", "member", "client"].includes(key) && !queryParams.has(key)) {
          queryParams.append(key, value);
        }
      });

      navigate({ pathname: "/", search: `?${queryParams.toString()}` });
    } else {
      setTransitionDirection("left");
      setDirection(-1);
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="explainer-wrapper">
      <div className="heading">
        <p>What Does Quadrant Flow Measure?</p>
      </div>

      <div className="assessment-categories">
        {windowWidth < 650 ? (
          <AnimatePresence mode='wait'>
            <motion.div
              key={currentIndex}
              className={`category active-card ${transitionDirection === "left" ? "slide-in-left" : "slide-in-right"} `}
            // initial={{ opacity: 0, x: direction > 0 ? 50 : -50 }}
            // animate={{ opacity: 1, x: 0 }}
            // exit={{ opacity: 0, x: direction > 0 ? -50 : 50 }}
            // transition={{ duration: 0.5 }}
            >
              <div className="image-and-description-wrapper">
                <div className="image" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img
                    src={categories[currentIndex].image}
                    loading="eager"
                    style={{
                      maxHeight: "200px",
                      maxWidth: "200px",
                      borderRadius: "10px"
                    }}
                    alt="thumbnail"
                  />
                </div>
                <div className="title">
                  <h2>{categories[currentIndex].title}</h2>
                </div>
                <div className="description">
                  <p>
                    {Array.isArray(categories[currentIndex].description)
                      ? categories[currentIndex].description.map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))
                      : categories[currentIndex].description}
                  </p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        ) : (
          categories.map((category, index) => (
            <motion.div
              key={index}
              className={`category ${index === currentIndex ? "active-card" : index < currentIndex ? "visible-card" : "hidden-card"}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="image" style={{ height: index <= currentIndex ? 'auto' : '100%', display: !index <= currentIndex ? 'flex' : '', alignItems: !index <= currentIndex ? 'center' : '', justifyContent: !index <= currentIndex ? 'center' : '' }} >
                <img src={index <= currentIndex ? category.image : emptyImage}
                  style={{
                    maxHeight: index <= currentIndex ? "200px" : "132.49px",
                    maxWidth: index <= currentIndex ? "200px" : "138px",
                    position: index <= currentIndex ? "relative" : "relative",
                    top: index > currentIndex ? "0" : null,
                    right: index > currentIndex ? "0" : null,
                    borderRadius: "10px"
                  }}

                  alt="thumbnail" />
              </div>
              {index <= currentIndex && (
                <>
                  <div className="title">
                    <h2>{category.title}</h2>
                  </div>
                  <div className="description">
                    <p>{Array.isArray(category.description)
                      ? category.description.map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))
                      : category.description}</p>
                  </div>
                </>
              )}
            </motion.div>
          ))
        )}
      </div>

      {/* Progress Indicator */}
      <div className="progress-indicator">
        {categories.map((_, index) => (
          <span key={index} className={`dot ${index === currentIndex ? "active" : ""}`}></span>
        ))}
      </div>

      <div className="buttons">
        <>
          <button
            className="back-btn"
            onClick={handleBack}
          >
            <WestIcon /> Back
          </button>
          <button
            className="next-btn"
            onClick={handleNext}
          // disabled={currentIndex === categories.length - 1}
          >
            Next <EastIcon />
          </button>
        </>
      </div>
    </div>
  );
}

export default Explainer
